
import Vue from 'vue'

import CustomTextModal from './CustomTextModal.vue'
import GoToButtonLink from './GoToButtonLink.vue'

export default Vue.extend({
  name: 'UpgradeSuccessfulModal',
  components: {
    CustomTextModal,
    GoToButtonLink,
  },
  props: {
    planName: {
      type: String,
    },
  },
})
